import root from '@/router/middleware/root'

import LeasingIndex from '@/views/leasings'
import leasings from '@/views/leasings/Leasings.vue'
import leasing from '@/views/leasings/Leasing.vue'

import LeasingItemIndex from '@/views/leasings/leasingItem'
import application from '@/views/leasings/Application.vue'
import personalDataConsent from '@/views/leasings/PersonalDataConsent.vue'

const routes = {
    path: '/leasings',
    name: 'leasings',
    component: LeasingIndex,
    meta: {
        middleware: [root]
    },
    children: [
        {
            path: '',
            name: 'leasings.leasings',
            component: leasings,
            meta: {
                fullWidth: true,
                middleware: [root]
            }
        },
        {
            path: ':id',
            name: 'leasings.leasing',
            component: LeasingItemIndex,
            meta: {
                middleware: [root]
            },
            children: [
                {
                    path: '',
                    name: 'leasings.leasing.item',
                    component: leasing,
                    meta: {
                        middleware: [root]
                    }
                },
                {
                    path: 'application',
                    name: 'leasings.leasing.application',
                    component: application,
                    meta: {
                        fullWidth: true,
                        middleware: [root]
                    }
                },
                {
                    path: 'personal-data-consent',
                    name: 'leasings.leasing.personal-data-consent',
                    component: personalDataConsent,
                    meta: {
                        fullWidth: true,
                        middleware: [root]
                    }
                }
            ]
        }
    ]
}

export default routes